<template>
  <div class="searchbox">
    <b-container fluid>
      <b-row class="justify-content-md-center">
       <b-col sm="7">
          <b-form-textarea
            id="search-textarea"
            placeholder="Enter search log..."
            rows="2"
            max-rows="10"
            v-model="search.log"
          ></b-form-textarea>
        </b-col>
        <b-col class="searchbutton" align-self="start" sm="2">
        <b-button v-if="loading === true" variant="dark" disabled>
          <b-spinner small type="grow"></b-spinner>
            Searching...
        </b-button>
        <b-button v-if="loading === false" variant="dark" @click="execSearch" >  Search  </b-button>
        </b-col>
      </b-row>
      <b-row class="option" align-h="center">
        <b-col sm="9">
          <div href="#" v-b-toggle.filter-option>
            <font-awesome-icon :icon="['fas', 'filter']" />
            <span>Set filter</span>
          </div>
          <b-collapse v-on:hidden="resetFilter" id="filter-option" class="mt-2">
            <b-card>
              <b-form inline>
                <label class="sr-only" for="inline-form-input-target">Target</label>
                <b-input
                  id="target"
                  class="mb-2 mr-sm-2 mb-sm-0"
                  placeholder="Target filter"
                  v-model="search.target"
                ></b-input>
                <label class="sr-only" for="inline-form-input-version">Version</label>
                <b-input
                  id="version"
                  class="mb-3 mr-sm-3 mb-sm-0"
                  placeholder="Version filter"
                  v-model="search.version"
                ></b-input>
              </b-form>
            </b-card>
          </b-collapse>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import firebase from 'firebase'
import axios from 'axios'
const apiUrl = 'https://logcrow.appspot.com/'
// const apiUrl = 'http://192.168.212.101:9999/'
// const apiUrl = 'http://localhost:9999/'
export default {
  name: 'SearchBox',
  props: {},
  data() {
    return {
      search: {
        log: "",
        target: "",
        version: ""
      },
      loading: false
    }
  },
  methods: {
    makeToast(variant = null, message) {
      this.$root.$bvToast.toast(message, {
        title: `${variant || 'message'}`,
        variant: variant,
        solid: true
      })
    },
    execSearch() {
      this.loading = true
      this.$store.commit('setLogs', [])
      let currentUser = firebase.auth().currentUser
      if (currentUser) {
        // ログイン状態での検索処理
        currentUser.getIdToken(true).then(async (idToken) => {
          let res = await axios.get(apiUrl + 'log', {
            headers: {
              'Authorization': `Bearer ${idToken}`,
              'Content-Type': 'appliction/json'
            },
            params: {
              search: this.searchLog,
              target: this.search.target,
              version: this.search.version,
              scope: 'public',
              current_page: this.currentPage -1,
              per_page: 20
            }
          })
          if (res.data.logs) {
            this.$store.commit('setLogs', res.data.logs)
            this.$store.commit('setTotalRows', res.data.hits_count)
            this.$store.commit('setPerPage', 20)
            this.loading = false
          } else {
            this.makeToast('warning', "No search result...")
            this.loading = false
          }
        }).catch(() => {
          this.reset()
        })
      } else {
        // 未ログイン状態での検索処理
        let search = async () => {
          let res = await axios.get(apiUrl + 'log', {
            params: {
              search: this.searchLog,
              target: this.search.target,
              version: this.search.version,
              scope: 'public',
              current_page: this.currentPage - 1,
              per_page: 20
            }
          })
          if (res.data.logs) {
            this.$store.commit('setLogs', res.data.logs)
            this.$store.commit('setTotalRows', res.data.hits_count)
            this.$store.commit('setPerPage', 20)
            this.loading = false
          } else {
            this.makeToast('warning', "No search result...")
            this.reset()
          }
        }
        search()
      }
    },
    reset() {
      this.search.log = ''
      this.resetFilter()
      this.loading = false
      this.$store.commit('setLogs', [])
    },
    resetFilter() {
      this.search.target = ''
      this.search.version = ''
    }
  },
  computed: {
    currentPage() {
      return this.$store.getters.currentPage
    },
    searchLog() {
      let replaced = this.search.log.replace(/\r?\n/g, ' ')
      return replaced
    }
  },
  watch: {
    currentPage() {
      this.execSearch()
    }
  }
}
</script>

<style>
.searchbutton{
  text-align: start;
}
.option {
    text-align: left;
}
</style>
